import { CloseCircleFilled } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import { lang } from './lang'
import s from './CollapseHeader.module.css'

interface Props {
  icon: ReactNode
  title: string
  limit: ReactNode
  shouldShowLimit?: boolean
  shouldShowChangeButton?: boolean
  shouldShowCloseButton?: boolean
  onChange?: () => void
  onClose?: () => void
}

function CollapseHeader({
  icon,
  title,
  limit,
  shouldShowChangeButton = false,
  shouldShowCloseButton = false,
  shouldShowLimit = false,
  onChange,
  onClose,
}: Props) {
  return (
    <Flex justify="space-between" align="center">
      <Flex gap={8}>
        <div className={s.collapsePanelIcon}>{icon}</div>
        <Flex vertical gap={4}>
          <Text fontSize={14} fontType="body" color="var(--grey-100)">
            {title}
          </Text>
          {shouldShowLimit && limit}
        </Flex>
      </Flex>
      <Flex gap={8} align="center">
        {shouldShowChangeButton ? (
          <Button type="link" style={{ padding: '0' }} size="small" onClick={onChange}>
            <FormattedMessage {...lang.change} />
          </Button>
        ) : null}
        {shouldShowCloseButton ? (
          <Button size="small" icon={<CloseCircleFilled />} type="link" onClick={onClose} className={s.closeButton} />
        ) : null}
      </Flex>
    </Flex>
  )
}

export default CollapseHeader
